import LineResult from "slotworks/model/gameplay/records/results/line-result";
import Contract from "slotworks/utils/contract";
import CelebrateWinComponent from "slotworks/components/celebrate-win/celebrate-win-component";

export default class ICCelebrateWinComponent extends CelebrateWinComponent {

    public singleTotalWin(win: number, result: LineResult) {
        if(!result.matches)
            return Contract.empty();            
        return super.singleTotalWin(win, result);        
    }

}
